// imported once globally for vehicle search, component vehicle search and landing pages to prevent errors
import VueRouter from 'vue-router';
window.VueRouter = VueRouter;

/* FLARE */
// import { flare } from "@flareapp/flare-client";
//
// if (process.env.NODE_ENV === 'production') {
//     if(window.sharedData !== undefined && window.sharedData.flare_js_key !== undefined) {
//         if(window.sharedData.flare_js_key !== null && window.sharedData.flare_js_key.length !== 0) {
//             flare.light(window.sharedData.flare_js_key);
//         }
//     }
// }

// Lazysizes
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Bootstrap
import swal from "sweetalert2";

require('./bootstrap');

/** http://plugins.krajee.com/file-input */
require('bootstrap-fileinput');
require('bootstrap-fileinput/js/locales/de.js');
//require('bootstrap-fileinput/js/plugins/piexif.min.js');
require('bootstrap-fileinput/themes/explorer/theme.min.js');

// Slick
require('slick-carousel');
require('slick-lightbox');

require('jquery.easing');
require('./jquery.isonscreen.min');

/* FontAwesome */
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

/* Daterangepicker */
import "daterangepicker";

/* Timepicker */
import "timepicker";

// IE Support ...
/**
 * detect IEEdge
 * returns version of IE/Edge or false, if browser is not a Microsoft browser
 */
function detectIEEdge() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // var edge = ua.indexOf('Edge/');
    // if (edge > 0) {
    //     // Edge => return version number
    //     return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    // }

    // other browser
    return false;
}

if (typeof NodeList !== "undefined" && NodeList.prototype) {
    // forEach
    if (!NodeList.prototype.forEach) {
        // Yes, there's really no need for `Object.defineProperty` here
        // console.log("Added forEach");
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    // Iterability - won't happen on IE11 because it doesn't have Symbol
    if (typeof Symbol !== "undefined" && Symbol.iterator && !NodeList.prototype[Symbol.iterator]) {
        // console.log("Added Symbol.iterator");
        Object.defineProperty(NodeList.prototype, Symbol.iterator, {
            value: Array.prototype[Symbol.iterator],
            writable: true,
            configurable: true
        });
    }
}

// JQuery Passive
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function(n, x, s, c) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
        num = this.toFixed(Math.max(0, ~~n));
    return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};

$(document).on('scroll', function (e) {
    e.stopPropagation();
    let scrolled = $(this).scrollTop();

    if ( scrolled > 350 ) {
        $('body').addClass('is-scrolled');
    } else {
        $('body').removeClass('is-scrolled');
    }

});


function countUp(facts_scrolled) {
    $('.countUp').each(function () {
        if (facts_scrolled[$(this).attr('data-countid')] === undefined && isElementInViewport($(this))) {
            let $this = $(this),
                countTo = $this.attr('data-count');
            // let n = (countTo - Math.floor(countTo) !== 0) ? 1 : 0;
            let n = (countTo.toString().split('.')[1] || '').length;

            // console.log((parseFloat(countTo).toString().split('.')[1] || '').length);

            $({countNum: 0}).animate({
                    countNum: countTo
                },
                {
                    duration: Math.floor(Math.random() * 5000) + 3000,
                    easing: 'easeOutQuad',
                    step: function () {
                        // $this.text(Math.floor(this.countNum).format(0, 3, '.', ','));
                        $this.text((this.countNum).format(n, 3, '.', ','));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    },
                    complete: function () {
                        // $this.text(Math.floor(this.countNum).format(0, 3, '.', ','));
                        $this.text((this.countNum).format(n, 3, '.', ','));
                        facts_scrolled[$this.attr('data-countid')] = 'true';
                    }
                });
        }

    });
}

// vehicle fav list
window.vehiclesParked = [];

let facts_scrolled = [];

$(document).on('scroll', function (e) {
    countUp(facts_scrolled);
});
countUp(facts_scrolled);

$(document).bind('mouseup touchend', function(e) {
    let container = $("a.card-image");
    // let containerbtn = $(".floating-btn");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('a.card-image').removeClass('hover');
    }
});

document.querySelectorAll('[data-target^="jumpmark"]').forEach(a => {
    a.addEventListener('click', function (e) {
        e.preventDefault();
        var href = this.getAttribute("href");
        var elem = $(href);

        $('html,body').animate({
            scrollTop: elem.offset().top - 150
        }, 500);
    });
});

$(document).on('click', '[data-target=toggle-see-more]', function(e) {
    e.preventDefault();

    var container_id = $(this).data('id');

    if(container_id !== undefined) {
        var container = document.getElementById(container_id);

        // console.log(container);
        // console.log(container_id);

        if(container !== undefined) {

            var span_open = $(this).find('span')[0];
            // var span_close = $(this).find('span')[1];

            $(this).remove();

            if(container.classList.contains('active')) {
                container.classList.remove('active');
                if(span_open.classList.contains('d-none')) {
                    span_open.classList.remove('d-none');
                    span_open.classList.add('d-block');
                }
                // if(span_close.classList.contains('d-block')) {
                //     span_close.classList.remove('d-block');
                //     span_close.classList.add('d-none');
                // }
            } else {
                container.classList.add('active');
                // if(span_close.classList.contains('d-none')) {
                //     span_close.classList.remove('d-none');
                //     span_close.classList.add('d-block');
                // }
                if(span_open.classList.contains('d-block')) {
                    span_open.classList.remove('d-block');
                    span_open.classList.add('d-none');
                }
            }

            // console.log('clicked');
        }
    }
});

$(document).on('click', '[data-target=toggle-see-more-compare]', function(e) {
    e.preventDefault();

    var container_id = $(this).data('id');

    if(container_id !== undefined) {
        var container = document.getElementById(container_id);

        if(container !== undefined) {
            container.classList.add('active');
            $(this).addClass('d-none');
        }
    }
});

$(document).scroll(function () {
    var scroll = $(window).scrollTop();
    var screen = $(window).height();

    var getFilterCollapse = document.getElementById('filterCollapse');

    if (checkGrid() === 'LG' || checkGrid() === 'XL') {
        if (scroll > screen) {
            $('.to-top-toggle').addClass('show-up');
        } else {
            $('.to-top-toggle').removeClass('show-up');
        }
    } else {

        // if(getFilterCollapse !== undefined && getFilterCollapse !== null) {
            if (scroll > screen * 2) {
                $('.to-top-toggle').addClass('show-up');
            } else {
                $('.to-top-toggle').removeClass('show-up');
            }
        //
        //     if(getFilterCollapse.classList.contains('show')) {
        //         $('#filterCollapse').isOnScreen(function(div) {
        //             if(div.top >= -50 && div.bottom >= -50) {
        //                 $('.to-top-toggle').removeClass('show-up');
        //             }
        //         });
        //     }
        // }
    }
});

$(document).ready(function() {

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            equalHeights();
            // reset overlays/menus
            // $('#nav-container').removeClass('active');
            // $('.btn-nav').removeClass('active');
            // $('body').removeClass('nav-overflow');
            // $('body').removeClass('has-active-menu');
            $('.slider').not('.slick-initialized').slick('resize');
        }, 100);
    });

    if(detectIEEdge() !== false) {
        var ie_compatible_classes = document.querySelectorAll('[data-ie^="incompatible"]');
        var ie_compatible_hide_wihout_message = document.querySelectorAll('[data-ie-hide^="true"]');

        for (var i = 0; i < ie_compatible_classes.length; i++) {
            if(ie_compatible_classes[i].classList.contains('d-none')) {
                // console.log('Incompatible function detected');
                ie_compatible_classes[i].classList.remove('d-none');
            }
        }

        for (var j = 0; j < ie_compatible_hide_wihout_message.length; j++) {
            if(!ie_compatible_hide_wihout_message[j].classList.contains('d-none')) {
                // console.log('Incompatible function detected');
                ie_compatible_hide_wihout_message[j].classList.add('d-none');
            }
        }
    }

    // Klaro: get config
    $('#klaro-get-config').on('click', function (e) {
        return klaro.show();
    });

    // is klaro defined
    if(typeof klaro === "object") {
        if(klaro.getManager().consents.yumpu === false) {
            $('.yumpu-wrapper').show();
        } else {
            $('.yumpu-wrapper').hide();
        }

        $('.btn-consent-settings-yumpu').on('click', function (e) {
            e.preventDefault();
            klaro.getManager().updateConsent('yumpu', true);
            $('.yumpu-wrapper').hide();
            klaro.getManager().saveAndApplyConsents();
        });

        if(klaro.getManager().consents.reonic === false) {
            $('.reonic-wrapper').show();
        } else {
            $('.reonic-wrapper').hide();
        }

        $('.btn-consent-settings-reonic').on('click', function (e) {
            e.preventDefault();
            klaro.getManager().updateConsent('reonic', true);
            $('.reonic-wrapper').hide();
            klaro.getManager().saveAndApplyConsents();
        });

        if(klaro.getManager().consents.autouncle === false) {
            $('.autouncle-wrapper').show();
        } else {
            $('.autouncle-wrapper').hide();
        }

        $('.btn-consent-settings-autouncle').on('click', function (e) {
            e.preventDefault();
            klaro.getManager().updateConsent('autouncle', true);
            $('.autouncle-wrapper').hide();
            klaro.getManager().saveAndApplyConsents();
        });
    }

    setTimeout(function() {
        equalHeights();
    }, 100);

    var hash = location.hash.replace(/^#/, '');
    if (hash) {
        var $selector = document.getElementById(hash);

        if($selector) {
            $('html,body').animate({
                scrollTop: $($selector).offset().top - 150
            }, 500);
        }
    }

    const hero_slider = document.getElementById('hero') || false;


    $('[data-action=delete-file]').click(function(e) {

        e.preventDefault();

        var el = $(this);
        var target = el.data('target');
        var route = el.data('route');

        axios.get(route)
            .then((response) =>  {
                $(target).remove();
            })
            .catch(() => {
                swal(
                    'Fehler!',
                    'Es ist ein Fehler aufgetreten!',
                    'error'
                )
            });
    });

    $('a.card-image').on("touchstart", function (e) {
        'use strict'; //satisfy code inspectors
        let link = $(this); //preselect the link
        if (link.hasClass('hover')) {
            return true;
        }
        else {
            link.addClass('hover');
            $('a.card-image').not(this).removeClass('hover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    $('.sidebar-btn--location').on('click', function(e) {
        e.preventDefault();
        if($('#sidebar-container--location').hasClass('active')) {
            $('#sidebar-container--location').removeClass('active');
            $(this).removeClass('active');
            $('body').removeClass('sidebar-overflow');

            $('.sidebar-modal-btn').removeClass('active');
            $('#sidebar-container').removeClass('active');
        } else {
            $('.sidebar-btn--contact').removeClass('active');
            $('.sidebar-btn--workshop').removeClass('active');
            $('.sidebar-btn--parked').removeClass('active');
            $('#sidebar-container--contact').removeClass('active');
            $('#sidebar-container--workshop').removeClass('active');
            $('#sidebar-container--parked').removeClass('active');

            $('#sidebar-container--location').addClass('active');
            $(this).addClass('active');
            $('body').addClass('sidebar-overflow');

            $('.sidebar-modal-btn').addClass('active');
            $('#sidebar-container').addClass('active');
        }
    });

    $('.sidebar-btn--contact').on('click', function(e) {
        e.preventDefault();
        if($('#sidebar-container--contact').hasClass('active')) {
            $('#sidebar-container--contact').removeClass('active');
            $(this).removeClass('active');
            $('body').removeClass('sidebar-overflow');

            $('.sidebar-modal-btn').removeClass('active');
            $('#sidebar-container').removeClass('active');
        } else {
            $('.sidebar-btn--location').removeClass('active');
            $('.sidebar-btn--workshop').removeClass('active');
            $('.sidebar-btn--parked').removeClass('active');
            $('#sidebar-container--location').removeClass('active');
            $('#sidebar-container--workshop').removeClass('active');
            $('#sidebar-container--parked').removeClass('active');

            $('#sidebar-container--contact').addClass('active');
            $(this).addClass('active');
            $('body').addClass('sidebar-overflow');

            $('.sidebar-modal-btn').addClass('active');
            $('#sidebar-container').addClass('active');
        }
    });

    $('.sidebar-btn--workshop').on('click', function(e) {
        e.preventDefault();
        if($('#sidebar-container--workshop').hasClass('active')) {
            $('#sidebar-container--workshop').removeClass('active');
            $(this).removeClass('active');
            $('body').removeClass('sidebar-overflow');

            $('.sidebar-modal-btn').removeClass('active');
            $('#sidebar-container').removeClass('active');
        } else {
            $('.sidebar-btn--location').removeClass('active');
            $('.sidebar-btn--contact').removeClass('active');
            $('.sidebar-btn--parked').removeClass('active');
            $('#sidebar-container--location').removeClass('active');
            $('#sidebar-container--contact').removeClass('active');
            $('#sidebar-container--parked').removeClass('active');

            $('#sidebar-container--workshop').addClass('active');
            $(this).addClass('active');
            $('body').addClass('sidebar-overflow');

            $('.sidebar-modal-btn').addClass('active');
            $('#sidebar-container').addClass('active');
        }
    });

    $('.sidebar-btn--parked').on('click', function(e) {
        e.preventDefault();
        if($('#sidebar-container--parked').hasClass('active')) {
            $('#sidebar-container--parked').removeClass('active');
            $(this).removeClass('active');
            $('body').removeClass('sidebar-overflow');

            $('.sidebar-modal-btn').removeClass('active');
            $('#sidebar-container').removeClass('active');
        } else {
            $('.sidebar-btn--location').removeClass('active');
            $('.sidebar-btn--contact').removeClass('active');
            $('.sidebar-btn--workshop').removeClass('active');
            $('#sidebar-container--location').removeClass('active');
            $('#sidebar-container--contact').removeClass('active');
            $('#sidebar-container--workshop').removeClass('active');

            $('#sidebar-container--parked').addClass('active');
            $(this).addClass('active');
            $('body').addClass('sidebar-overflow');

            $('.sidebar-modal-btn').addClass('active');
            $('#sidebar-container').addClass('active');

            listParkedVehicles();
        }
    });

    $('.btn-nav').on('click', function(e) {
        e.preventDefault();
        if($('#nav-container').hasClass('active')) {
            $('#nav-container').removeClass('active');
            $('.btn-nav').removeClass('active');
            $('body').removeClass('nav-overflow');
            $('body').removeClass('has-active-menu');

        } else {
            $('#sidebar-container').removeClass('active');
            $('.sidebar-btn--contact').removeClass('active');
            $('.sidebar-btn--location').removeClass('active');
            $('.sidebar-btn--workshop').removeClass('active');
            $('.sidebar-btn--parked').removeClass('active');
            $('#sidebar-container--contact').removeClass('active');
            $('#sidebar-container--location').removeClass('active');
            $('#sidebar-container--workshop').removeClass('active');
            $('#sidebar-container--parked').removeClass('active');

            $('#nav-container').addClass('active');
            $('.btn-nav').addClass('active');
            $('body').addClass('nav-overflow');
            $('body').addClass('has-active-menu');
            $('body').removeClass('sidebar-overflow');

        }
    });

    /* Transitions Only After Page Load */
    $('body').removeClass('preload');


    /* Slick Lightbox */
    $('.lightbox').slickLightbox({
        src: 'href',
        itemSelector: ' a',
        caption: 'caption'
    });

    $('.lightbox-with-links').slickLightbox({
        src: 'href',
        itemSelector: 'a.lightbox-link',
        caption: 'caption'
    });


    $('[data-action=load]').click(function(e) {
        e.preventDefault();
        let el = $(this);
        axios.post(el.data('href'), {})
            .then((response) =>  {
                // console.log(response.data);
                $(el.data('target')).html(response.data);
            });

    });

    if(typeof window.livewire !== 'undefined') {
        window.livewire.onError(statusCode => {
            if (statusCode === 419 || statusCode === 404 || statusCode === 500) {
                return false
            }
        });
    }

    $(document).on('click', '[data-smooth-scroll]', function(e) {
        e.preventDefault();
        let targetId = $(this).data('smooth-scroll');
        let offset = 80;

        if ($(this).data('offset')) {
            offset = parseInt( $(this).data('offset') );
        }

        if ($(targetId).length) {
            $('html, body').animate({
                scrollTop: $(targetId).offset().top - offset
            }, 500);
        }
    });


    $(document).on('click', 'a.vehicle-teaser', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let url = $(this).attr('href') ;
        let parkVehicle = null;
        let disclaimer = null;

        // park vehicle button
        if( $(e.target).hasClass('park-vehicle') ) {
            parkVehicle = $(e.target);
        } else if( $(e.target).parents('.park-vehicle').length ) {
            parkVehicle = $(e.target).parents('.park-vehicle');
        }

        // disclaimer icon
        if( $(e.target).hasClass('disclaimer') || $(e.target).parents('.disclaimer').length ) {
            return false;
        }

        if(parkVehicle) {

            // animate only when adding and for desktop
            if ($(window).outerWidth() >=  992 && parkVehicle.hasClass('parked')) {
                let parkedVehicleCount = $('#parkedVehicleCount');
                let heartIcon = parkVehicle.find('span.show-parked i.custom-icon');
                flyToAnimation(heartIcon, parkedVehicleCount);
            }

            listParkedVehicles();
            return false;
        }

        window.open(url,"_self");
    });

});

function checkGrid() {
    if ($(window).width() >= 1200) return 'XL';
    if ($(window).width() >=  992) return 'LG';
    if ($(window).width() >=  768) return 'MD';
    if ($(window).width() >=  576) return 'SM';
    return 'XS';
}

function setEqualHeights(children) {
    let fixedHeight = 0;
    children.each(function (i, c) {
        $(c).attr('style', ''); // reset
        let height = $(c).outerHeight();
        if ( height > fixedHeight ) {
            fixedHeight = height;
        }
    });

    children.each(function (i, c) {
        if (checkGrid() === 'LG' || checkGrid() === 'XL') {
            $(c).css({'height': fixedHeight + "px"});
        } else {
            $(c).attr('style', '');
        }
    });
}

window.equalHeights = function() {
    $('[data-eqh-parent]').each(function (i, p) {

        let eqhGroups = {};
        let children = $(p).find('[data-eqh]');

        children.each(function (i, c) {
            let eqh = $(c).data('eqh');
            if(eqhGroups[eqh]) {
                eqhGroups[eqh].push($(c));
            } else {
                eqhGroups[eqh] = $(c);
            }
        });

        $.each(eqhGroups, function(i, g){
            setEqualHeights(g);
        });

    });
}

function isElementInViewport (el) {

    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}

$('body').on('click', '[data-toggle=tab]', function (e) {
    const active_tab = $(this);
    updateQueryStringParameter(location.href, 'current_tab', active_tab.data('tab'), active_tab.text());
});

function updateQueryStringParameter(uri, key, value, title) {

    var url = '';
    var data = {};
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (uri.match(re)) {
        url = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        url = uri + separator + key + "=" + value;
    }

    data[key] = value;

    window.history.pushState(data, title, url);

    return url;
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function listParkedVehicles() {
    let cookie = getCookie('vehicles_parked');
    let vehicles_parked = [];

    if(cookie !== null) {
        vehicles_parked = JSON.parse(decodeURIComponent(cookie));
        // just to be sure
        vehicles_parked = _.uniq(vehicles_parked);
    }

    if(typeof window.online_vehicle_ids !== 'undefined') {
        // remove vehicles that are no longer online
        let onlineVehicleIds = window.online_vehicle_ids;
        let vehiclesOnline = [];

        $.each(vehicles_parked, function(index, v) {
            if(_.includes(onlineVehicleIds, v.id)) {
                vehiclesOnline.push(v);
            }
        });

        vehicles_parked = vehiclesOnline;
        let vehiclesParkedJson = JSON.stringify(vehicles_parked);
        setCookie('vehicles_parked', vehiclesParkedJson, 90);
    }

    window.vehiclesParked = vehicles_parked;

    // set counter
    if(vehicles_parked.length !== 0) {
        $('#parkedVehicleCount').text(vehicles_parked.length);
    } else {
        $('#parkedVehicleCount').empty();
    }

    if( (vehicles_parked.length > 1 && vehicles_parked.length < 4) ) {
        $('#parkedVehiclesCount').text(vehicles_parked.length);
    } else {
        $('#parkedVehiclesCount').empty();
    }

    // dom stuff
    $('#parkedVehiclesList').empty();
    if(vehicles_parked.length > 0) {

        $('.parked-vehicles-empty').hide();
        $('.parked-vehicles-list').show();

        if(vehicles_parked.length > 3) {
            $('.parked-vehicles-list').removeClass('hide-check');
        } else {
            $('.parked-vehicles-list').addClass('hide-check');
        }

        if(vehicles_parked.length > 1) {
            $('.parked-vehicles-list').addClass('multiple');
        } else {
            $('.parked-vehicles-list').removeClass('multiple');
        }


        if( vehicles_parked.length > 1 && vehicles_parked.length < 4 ) {
            $('.parked-vehicles-list').addClass('enabled');
        } else {
            $('.parked-vehicles-list').removeClass('enabled');
        }

        $.each(vehicles_parked, function(index, v) {

            $('#parkedVehiclesList').append(`
                <li>
                    <div class="custom-control custom-checkbox pr-m">
                        <input type="checkbox" class="custom-control-input" id="parkedCompareId-`+v.id+`" name="compare_ids[]" value="`+v.id+`">
                        <label class="custom-control-label w-100" for="parkedCompareId-`+v.id+`">
                            <div class="text-truncate">`+v.name+`</div>
                        </label>
                    </div>
                    <strong class="mr-xs">` +
                        parseFloat(v.price).format(0, null, '.', ',') +
                    ` €</strong>
                    <a href="`+v.url+`">Zum Fahrzeug</a>
                    <a href="#" data-unpark-vehicle-id="`+v.id+`" data-toggle="tooltip" data-placement="left" title="Löschen aus Merkliste">
                        <i class="fa fa-trash"></i>
                    </a>
                </li>
            `);

        });
    } else {
        $('.parked-vehicles-list').hide();
        $('.parked-vehicles-empty').show();
    }
}
// trigger to get cookie going
listParkedVehicles();

// fix for dynamically added tooltips
$('body').tooltip({
    selector: '[data-unpark-vehicle-id], .park-vehicle'
});

function isParked(id) {
    let vehiclesParked = window.vehiclesParked;
    let isParked = _.find(vehiclesParked, function(v) { return v.id === id; });

    return typeof isParked !== 'undefined';
}

function parkVehicle(id, name, price, url) {

    let vehiclesParked = window.vehiclesParked;
    let car = new Object({
        id: id,
        name: name,
        price: price,
        url: url,
    });

    if(isParked(id)) {
        vehiclesParked = _.remove(vehiclesParked, function(v) {
            return v.id !== id;
        });
    } else {
        if(vehiclesParked.length < 9) {
            vehiclesParked.push(car);
        }
    }

    vehiclesParked = _.uniq(vehiclesParked);
    let vehiclesParkedJson = JSON.stringify(vehiclesParked);

    window.vehiclesParked = vehiclesParked;
    // reset cookie
    setCookie('vehicles_parked', vehiclesParkedJson, 90);

    listParkedVehicles();
}


$(document).on('change', '#parkedVehiclesCompareForm input[type="checkbox"]', function(evt) {
    let selectedParkedVehicles = $('#parkedVehiclesCompareForm input[type="checkbox"]:checked').length;

    if( selectedParkedVehicles > 3 ) {
        this.checked = false;
        selectedParkedVehicles = selectedParkedVehicles - 1;
        // show explaining tooltip
        $('#parkedVehiclesCompareSubmit').tooltip("show");
        // auto-hide
        setTimeout(() => {
            $('#parkedVehiclesCompareSubmit').tooltip("hide");
        }, 4000)
    }

    if( selectedParkedVehicles > 1 && selectedParkedVehicles < 4 ) {
        $('#parkedVehiclesCount').text(selectedParkedVehicles);
        $('.parked-vehicles-list').addClass('enabled');
    } else {
        $('#parkedVehiclesCount').empty();
        $('.parked-vehicles-list').removeClass('enabled');
    }
});


$(document).ready(function() {
    let checkedParkedOnLoad = $('.check-parked-on-load');

    if(checkedParkedOnLoad.length > 0) {

        $.each(checkedParkedOnLoad, function(index, obj) {

            let id = $(obj).data('park-vehicle-id');

            if(isParked(id)) {
                $(obj).addClass('parked');
            }
        });

    }
});


function flyToAnimation(elem1, elem2, startX, startY) {

    let elem1Clone = elem1.clone();
    let animStartX = startX || elem1.offset().left;
    let animStartY = startY || elem1.offset().top;
    let animEndX = elem2.offset().left;
    let animEndY = elem2.offset().top;

    elem1Clone.css({
        'opacity': 1,
        'position': 'absolute',
        'left': animStartX,
        'top': animStartY,
        'z-index': 999,
    })
        .appendTo($('body'))
        .animate({
            'opacity': 0,
            'left': animEndX,
            'top': animEndY,
        }, 1000, 'easeOutCirc', function() {
            elem1Clone.remove();
        });
}


$(document).on('click', '[data-park-vehicle-id]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    let id = parseInt( $(this).data('park-vehicle-id') );
    let name = $(this).data('park-vehicle-name');
    let price = parseInt( $(this).data('park-vehicle-price') );
    let url = $(this).data('park-vehicle-url');

    // animate only when adding and for desktop
    if ($(window).outerWidth() >=  992 && !$(this).hasClass('parked')) {
        let parkedVehicleCount = $('#parkedVehicleCount');
        let overrideHelper = $(this).find('span.hide-parked i.custom-icon');
        let overrideX = overrideHelper.offset().left;
        let overrideY = overrideHelper.offset().top;
        let heartIcon = $(this).find('span.show-parked i.custom-icon');
        flyToAnimation(heartIcon, parkedVehicleCount, overrideX, overrideY);
    }

    $(this).toggleClass('parked');
    parkVehicle(id, name, price, url);
});

function unparkVehicle(id) {
    let vehiclesParked = window.vehiclesParked;

    vehiclesParked = _.remove(vehiclesParked, function(v) {
        return v.id !== id;
    });

    let vehiclesParkedJson = JSON.stringify(vehiclesParked);

    window.vehiclesParked = vehiclesParked;
    // reset cookie
    setCookie('vehicles_parked', vehiclesParkedJson, 90);

    listParkedVehicles();
}

$(document).on('click', 'a[data-unpark-vehicle-id]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    // close any open tooltips
    $(".tooltip").tooltip("hide");
    let id = parseInt( $(this).data('unpark-vehicle-id') );
    unparkVehicle(id);

    $('[data-park-vehicle-id="' + id + '"]').removeClass('parked');
});


// WEBPACK FOOTER //
// ./resources/js/frontend.js